import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import { ICountryOrState, IListItem, IUserAddressRulesField } from 'base/interfaces/address'
import { checkCityInputType, getFormItemRules } from '@base/account/address/utils';
import ThemeLoading from '@base/lib/ThemeLoading';
import Iconfont from '@base/lib/Iconfont'
import { useTrans } from 'base/utils/i18n'
import { useRequest } from 'ahooks';
import Fuse from 'fuse.js';

type IProps = {
    cityLoading?: boolean;
    cityList: IListItem[];
    itemRules: IUserAddressRulesField;
    addressRules: IUserAddressRulesField[];
    onSelectCityHandle: (cityText: string) => void;
    currentCountryObj?: ICountryOrState;
}

const CityFormItem: React.FC<IProps> = (props) => {
    const {
        cityList: originCityList,
        cityLoading,
        itemRules,
        addressRules,
        onSelectCityHandle,
        currentCountryObj
    } = props;

    const [cityList, setCityList] = useState<IListItem[]>(originCityList);


    // city手输
    const isTextInput = checkCityInputType({
        countryCode: currentCountryObj?.code || '',
        rules: itemRules
    })

    const {
        key,
        labelTitle,
        placeholder,
    } = itemRules;

    const provinceRules = addressRules.find(iRules => iRules.key == 'provinceText');


    const { t } = useTrans();
    const form = Form.useFormInstance()

    const provinceText = form.getFieldValue('provinceText');

    const onDropdownVisibleChangeHandle = () => {
        setCityList(originCityList)
    }

    const onSearch = async (newValue: string) => {
        if (!newValue) {
            setCityList(originCityList)
        }

        const fuse = new Fuse(originCityList, {
            isCaseSensitive: false,
            keys: ['name']
        });
        const matchedList = fuse.search(newValue);
        setCityList(matchedList.map(item=>item.item));
    }

    const { run: onSearchDebounce } = useRequest(onSearch, {
        debounceWait: 400,
        manual: true,
    })

    useEffect(() => {
        setCityList(originCityList)
    }, [originCityList]);


    return (
        <Form.Item
            // dependencies={['countryText', 'provinceText']}
            label={labelTitle}
            name={key}
            rules={getFormItemRules(itemRules)}
        >
            {
                isTextInput ? (
                    <Input
                        placeholder={placeholder}
                        autoComplete={'no-fill'}
                    />
                ) : (
                    <Select
                        showSearch
                        // @ts-ignore, api 中没有该属性定义但实际支持
                        autoComplete={'no-fill'}
                        loading={cityLoading}
                        filterOption={false}
                        getPopupContainer={trigger => trigger.parentElement}
                        placeholder={placeholder}
                        notFoundContent={<>{cityLoading ?
                            <ThemeLoading/> :
                            <div dangerouslySetInnerHTML={{
                                __html: provinceText
                                    ? t('web_common_it_is_empty')
                                    : t('web_address_select_province_first', {
                                        label: provinceRules?.labelTitle || ''
                                    })
                            }}>
                            </div>
                        }</>}
                        onDropdownVisibleChange={onDropdownVisibleChangeHandle}
                        onChange={(e) => onSelectCityHandle(e)}
                        onSearch={(value) => onSearchDebounce(value)}
                        suffixIcon={<Iconfont className={'select-arrow icon-arrow-down'}/>}
                        options={cityLoading ? undefined : cityList?.map((oItem: any) => {
                            return {
                                value: oItem.name,
                                label: oItem.name,
                            }
                        })}
                    />
                )
            }
        </Form.Item>
    );
};

export default CityFormItem